import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_NE: MRT_Localization = {
  language: "ne",
  actions: "कार्यहरू",
  and: "र",
  cancel: "रद्द गर्नुहोस्",
  changeFilterMode: "फिल्टर मोड परिवर्तन गर्नुहोस्",
  changeSearchMode: "खोज मोड परिवर्तन गर्नुहोस्",
  clearFilter: "फिल्टर खाली गर्नुहोस्",
  clearSearch: "खोज खाली गर्नुहोस्",
  clearSelection: "चयन खाली गर्नुहोस्",
  clearSort: "क्रम खाली गर्नुहोस्",
  clickToCopy: "कपी गर्न क्लिक गर्नुहोस्",
  copy: "कपी",
  collapse: "संकुचित गर्नुहोस्",
  collapseAll: "सबै संकुचित गर्नुहोस्",
  columnActions: "स्तम्भ कार्यहरू",
  copiedToClipboard: "क्लिपबोर्डमा कपी गरियो",
  dropToGroupBy: "समूह गर्न {column} मा ड्रप गर्नुहोस्",
  edit: "सम्पादन",
  expand: "विस्तार गर्नुहोस्",
  expandAll: "सबै विस्तार गर्नुहोस्",
  filterArrIncludes: "समावेश गर्दछ",
  filterArrIncludesAll: "सबै समावेश गर्दछ",
  filterArrIncludesSome: "समावेश गर्दछ",
  filterBetween: "बीचमा",
  filterBetweenInclusive: "समावेशी बीचमा",
  filterByColumn: "{column} द्वारा फिल्टर गर्नुहोस्",
  filterContains: "समावेश गर्दछ",
  filterEmpty: "खाली",
  filterEndsWith: "सँग समाप्त हुन्छ",
  filterEquals: "बराबर",
  filterEqualsString: "बराबर",
  filterFuzzy: "फजी",
  filterGreaterThan: "भन्दा ठूलो",
  filterGreaterThanOrEqualTo: "भन्दा ठूलो वा बराबर",
  filterInNumberRange: "बीचमा",
  filterIncludesString: "समावेश गर्दछ",
  filterIncludesStringSensitive: "समावेश गर्दछ",
  filterLessThan: "भन्दा सानो",
  filterLessThanOrEqualTo: "भन्दा सानो वा बराबर",
  filterMode: "फिल्टर मोड: {filterType}",
  filterNotEmpty: "खाली छैन",
  filterNotEquals: "बराबर छैन",
  filterStartsWith: "सँग सुरु हुन्छ",
  filterWeakEquals: "बराबर",
  filteringByColumn: "{column} द्वारा फिल्टरिङ - {filterType} {filterValue}",
  goToFirstPage: "पहिलो पृष्ठमा जानुहोस्",
  goToLastPage: "अन्तिम पृष्ठमा जानुहोस्",
  goToNextPage: "अर्को पृष्ठमा जानुहोस्",
  goToPreviousPage: "अघिल्लो पृष्ठमा जानुहोस्",
  grab: "समात्नुहोस्",
  groupByColumn: "{column} द्वारा समूह गर्नुहोस्",
  groupedBy: "द्वारा समूह गरियो ",
  hideAll: "सबै लुकाउनुहोस्",
  hideColumn: "{column} स्तम्भ लुकाउनुहोस्",
  max: "अधिकतम",
  min: "न्यूनतम",
  move: "सार्नुहोस्",
  noRecordsToDisplay: "देखाउन कुनै रेकर्ड छैन",
  noResultsFound: "कुनै परिणाम फेला परेन",
  of: "को",
  or: "वा",
  pin: "पिन गर्नुहोस्",
  pinToLeft: "बायाँतिर पिन गर्नुहोस्",
  pinToRight: "दायाँतिर पिन गर्नुहोस्",
  resetColumnSize: "स्तम्भ आकार रिसेट गर्नुहोस्",
  resetOrder: "क्रम रिसेट गर्नुहोस्",
  rowActions: "पंक्ति कार्यहरू",
  rowNumber: "#",
  rowNumbers: "पंक्ति नम्बरहरू",
  rowsPerPage: "प्रति पृष्ठ पंक्तिहरू",
  save: "बचत गर्नुहोस्",
  search: "खोज्नुहोस्",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} मध्ये {rowCount} पंक्ति(हरू) चयन गरियो",
  select: "चयन गर्नुहोस्",
  showAll: "सबै देखाउनुहोस्",
  showAllColumns: "सबै स्तम्भहरू देखाउनुहोस्",
  showHideColumns: "स्तम्भहरू देखाउनुहोस्/लुकाउनुहोस्",
  showHideFilters: "फिल्टरहरू देखाउनुहोस्/लुकाउनुहोस्",
  showHideSearch: "खोज देखाउनुहोस्/लुकाउनुहोस्",
  sortByColumnAsc: "{column} द्वारा आरोही क्रममा सर्ट गर्नुहोस्",
  sortByColumnDesc: "{column} द्वारा अवरोही क्रममा सर्ट गर्नुहोस्",
  sortedByColumnAsc: "{column} द्वारा आरोही क्रममा सर्ट गरियो",
  sortedByColumnDesc: "{column} द्वारा अवरोही क्रममा सर्ट गरियो",
  thenBy: ", त्यसपछि ",
  toggleDensity: "घनत्व टगल गर्नुहोस्",
  toggleFullScreen: "पूर्ण स्क्रिन टगल गर्नुहोस्",
  toggleSelectAll: "सबै चयन टगल गर्नुहोस्",
  toggleSelectRow: "पंक्ति चयन टगल गर्नुहोस्",
  toggleVisibility: "दृश्यता टगल गर्नुहोस्",
  ungroupByColumn: "{column} द्वारा समूह रद्द गर्नुहोस्",
  unpin: "अनपिन गर्नुहोस्",
  unpinAll: "सबै अनपिन गर्नुहोस्",
};
